import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import createCustomTheme from './theme';
import { useAppTheme } from '../AppTheme';

export default function MUIThemeProvider({ children }) {
  const { resolvedTheme: mode } = useAppTheme();
  const theme = createCustomTheme(mode);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
